export default __webpack_public_path__ + "static/media/sidebar-teal.0301b2cf.png";